import '../../stylesheets/Map.css';
import { useSelector, useDispatch } from 'react-redux';
import { selectAllStrings } from '../language/languageSlice';
import Navbar from '../../app/Navbar';
import { useState, useEffect, useRef } from 'react';
import { Loader } from "@googlemaps/js-api-loader";
import { selectFoundPoiIds, searchPois } from '../pois/poisSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import constants from '../../constants';
import createPopupClass from './Popup';
import { parsePoiAdvantages, parsePoiAddress } from '../pois/parser';
import SearchModal from '../pois/SearchModal';
import { getPosition } from '../../api/mobile';
import { selectUserPosition, setUserPosition } from './mapSlice';
import { useHistory } from 'react-router';


const MapPage = () => {
    const strings = useSelector(selectAllStrings);
    const [inited, setInited] = useState(false);
    const userPosition = useSelector(selectUserPosition);
    const dispatch = useDispatch();

    const placesStatus = useSelector((state) => state.map.status);
    const placesError = useSelector((state) => state.map.error);

    const [poiTitle, setPoiTitle] = useState('');
    const [poiAdvantages, setPoiAdvantages] = useState('');
    const [poiAddress, setPoiAddress] = useState('');
    const [poiId, setPoiId] = useState(0);
    const mapRef = useRef(null);
    const popupRef = useRef(null);
    const updatePoisRef = useRef(null);
    const updatePositionRef = useRef(null);
    const defaultZoom = 12;
    const [showSearch, setShowSearch] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [loadingPlaces, setLoadingPlaces] = useState(false);


    let popup, map;


    const additionalOptions = {
        libraries: ["places"]
    };
    
    const loader = new Loader({
        apiKey: constants.maps_api_key,
        version: "weekly",
        ...additionalOptions,
    });
    let userMarker;

    const initMap = () => {
        loader.load().then(async () => {
            window.Google = google;
            let userPosition = await getPosition();
            map = window.map = new google.maps.Map(mapRef.current, {
                center: userPosition,
                zoom: defaultZoom,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: false,
                fullscreenControl: false,
                minZoom: 9,
                maxZoom: 18,
                styles: [
                    {
                        "featureType": "poi",
                        "stylers": [
                            {"visibility": "off"}

                        ]
                    }]
            });
            userMarker = new google.maps.Marker({
                position: userPosition,
                map: map,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillOpacity: 1,
                    strokeWeight: 2,
                    fillColor: '#5384ED',
                    strokeColor: '#ffffff',
                },
            });


            updatePlaces();
            window.Popup = createPopupClass(google.maps.OverlayView);
            updatePoisRef.current.onclick = (event) => {
                event.preventDefault();
                setLoadingPlaces(true);

                updatePlaces(() => setTimeout(() => setLoadingPlaces(false), 1000));
            };
            updatePositionRef.current.onclick = (event) => {
                event.preventDefault();
                updateUserPosition();
            };
        });
        setInited(true);


    };
    const [markers, setMarkers] = useState([]);

    const addMarkers = (pois) => {
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        setMarkers([]);

        for (let i = 0; i < pois.length; i++) {
            let position = new window.Google.maps.LatLng(pois[i].lat_poi.replace(',', '.'),
                    pois[i].lon_poi.replace(',', '.'));
            let markerColor = '#044A42';
            let hasClubBenefits = false;
            let hasOtherBenefits = false;
            let iconsUrl = constants.frontend_url + '/images/';
            let markerIcon;
            let categoryIcon;
            if (pois[i].cat_camping == 1) {
                markerColor = '#B8296A';
                hasOtherBenefits = true;
                categoryIcon = iconsUrl + 'campsites_benefits_marker.svg';
            } else if (pois[i].cat_areeservizio == 1) {
                markerColor = '#ED8160';
                hasOtherBenefits = true;
                categoryIcon = iconsUrl + 'service_benefits_marker.svg';
            } else if (pois[i].cat_areesosta == 1) {
                markerColor = '#047D70';
                hasOtherBenefits = true;
                categoryIcon = iconsUrl + 'parking_benefits_marker.svg';
            }

            if (pois[i].cat_convenzioni == 1) {
                hasClubBenefits = true;
            }

            if (hasClubBenefits && !hasOtherBenefits) {
                markerColor = '#EEBE35';

            }
            if (hasClubBenefits & hasOtherBenefits) {
                markerIcon = categoryIcon;
            } else {
                markerIcon = {
                    path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
                    scale: 0.05,
                    strokeWeight: 7,
                    strokeColor: 'black',
                    strokeOpacity: 0,
                    fillColor: markerColor,
                    fillOpacity: 1
                };
            }

            const marker = new window.Google.maps.Marker({
                position: position,
                icon: markerIcon,
                map: window.map
            });
            markers.push(marker);
            setMarkers(markers);

            const openPopup = () => {
                setPoiTitle(pois[i].nome_poi);
                setPoiAdvantages(parsePoiAdvantages(pois[i], strings));
                setPoiAddress(parsePoiAddress(pois[i]));
                setPoiId(pois[i].id_poi)
                popup = new window.Popup(position, popupRef.current);
                popup.setMap(window.map);
            };
            marker.addListener('click', openPopup);


        }
    };
    const applyFilters = async (filters, address) => {
        setLoadingPlaces(true);
        setShowSearch(false);
        setKeyword(address);

        const resultAction = await dispatch(searchPois({
            keyword: filters.poiKeyword,
            lat: filters.location.lat(),
            lng: filters.location.lng(),
            camp: filters.campsites,
            serv: filters.serviceAreas,
            sosta: filters.parkingAreas,
            conv: filters.clubBenefits,
            attr: filters.attractions,
            acc: filters.disabledAccessibility,
            pet: filters.petsAllowed,
            water: filters.water,
            cp: filters.cockpit,
            el: filters.electricity,
            limit: 70
        }));
        unwrapResult(resultAction);
        let pois = resultAction.payload;
        addMarkers(pois);
        if (typeof pois[0] !== 'undefined') {
            window.map.setCenter(new window.Google.maps.LatLng(pois[0].lat_poi.replace(',', '.'),
                    pois[0].lon_poi.replace(',', '.')));
        }
        setTimeout(() => setLoadingPlaces(false), 1000);
    };
    const updatePlaces = async (onComplete = f => f) => {
        try {
            const mapCenter = window.map.getCenter();
            const resultAction = await dispatch(searchPois({
                lat: mapCenter.lat(),
                lng: mapCenter.lng(),
                camp: true,
                serv: true,
                sosta: true,
                conv: true,
                limit: 70
            }));
            unwrapResult(resultAction);
            const pois = resultAction.payload;
            addMarkers(pois);
        } catch (err) {
            console.log('error: ', err);
        }
        onComplete();
    };
    useEffect(() => {
        if (!inited && mapRef.current !== null) {
            initMap();
        }
    }, [inited, mapRef]);


    const updateUserPosition = async () => {
        let newPosition = await getPosition(false);
        dispatch(setUserPosition(newPosition));
        window.map.setCenter(newPosition);
        window.map.setZoom(defaultZoom);
        updatePlaces();
        userMarker.setPosition(newPosition);
    };

    const history = useHistory();
    const openPoiDetails = () => {
        history.push(`/pois/${poiId}`);
    }



    return <div id="map_page">
        <input type="text" className="search" placeholder={strings.search_poi} readOnly value={keyword} onClick={event => setShowSearch(true)}/>
        <div id="map" ref={mapRef}></div>
    
        <div id="info_popup" ref={popupRef}>
            <div className="close">x</div>
            <div className="title" onClick={openPoiDetails} style={{cursor: 'pointer'}}>{poiTitle}</div>
            <div className="advantages" onClick={openPoiDetails} style={{cursor: 'pointer'}}>{poiAdvantages}</div>
            <div className="address" onClick={openPoiDetails} style={{cursor: 'pointer'}}>{poiAddress}</div>
        </div>
        <button id="update_pois" ref={updatePoisRef}><span className={'sync-icon' + (loadingPlaces ? ' rotating' : '')}></span></button>
        <button id="update_position" ref={updatePositionRef}></button>
        <Navbar/>
        <SearchModal show={showSearch} onGoBack={() => setShowSearch(false)} onApplyFilters={applyFilters} defaultLocation={userPosition}/>
    </div>
};

export default MapPage;